import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '~/components/common/Button';

import giftcard from '~/images/sportistas-giftcard1.png';

const GiftcardBanner = () => {
	const { t } = useTranslation();

	return (
		<div className="giftcard-banner">
			<div className="content-wrapper giftcard-content-wrapper">
				<div className="giftcard-container">
					<div className="details">
						<h2>{t('gift_card')}</h2>
						<p>{t('homepage_giftcard_text')}</p>
						<Link to="/giftcard">
							<Button color="light" outline={true}>
								{t('homepage_giftcard_button')}
							</Button>
						</Link>
					</div>
					<div className="giftcard-img">
						<img src={giftcard} alt="Sportistas Giftcard" loading="lazy" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default GiftcardBanner;
